import { render, staticRenderFns } from "./mingcai.vue?vue&type=template&id=4b43bffc&scoped=true&"
import script from "./mingcai.vue?vue&type=script&lang=js&"
export * from "./mingcai.vue?vue&type=script&lang=js&"
import style0 from "./mingcai.vue?vue&type=style&index=0&id=4b43bffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b43bffc",
  null
  
)

export default component.exports